import React from 'react';
import { AppState, Booking } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import { closeModalByGoingBackIfPossibleFallingBackToUrl, Modal } from '../common/modal';
import { History } from 'history';
import { PresentationComponentBase } from '../presentationComponentBase';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { connect } from 'react-redux';
import { LoginRequiredModal } from '../auth/loginRequiredModal';
import modificationStyle from 'acscp/components/booking/modificationRequest.module.scss';
import { ModificationRequestPage } from './modificationRequestPage';

interface ModifyModalOwnProps {
    booking: Booking;
}

interface ModifyModalStateProps {
    isLoggedIn: boolean;
}

class ModifyModalPresentational
        extends PresentationComponentBase<ModifyModalOwnProps, ModifyModalStateProps, {}, {}> {

    closeModal: (history: History) => void =
        closeModalByGoingBackIfPossibleFallingBackToUrl('/trip/' + this.props.booking.id);

    render(): JSX.Element {
        if (!this.props.isLoggedIn) {
            return <LoginRequiredModal closeUrl={'/trip/' + this.props.booking.id} />;
        }

        return (
            <Modal
                modalHeaderContent={
                    <FormattedMessage
                        id={'components.buttonrow.modificationButton.modalHeader'}
                        defaultMessage={'SUBMIT A CHANGE REQUEST'}
                    />
                }
                modalClassName={modificationStyle.Modal}
                modalHeaderClassName={modificationStyle.ModalHeader}
                closingModalClassName={modificationStyle.Cross}
                overlayClassName={modificationStyle.Overlay}
                modalBodyClassName={modificationStyle.ModalBody}
                isOpen={true}
                closeModal={this.closeModal}
            >
                <ModificationRequestPage bookingId={this.props.booking.id} closeModal={this.closeModal} />
            </Modal>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: ModifyModalOwnProps): ModifyModalStateProps {
    return {
        isLoggedIn: userIsLoggedIn(state.auth)
    };
}

export const ModifyModal = connect(mapStateToProps)(ModifyModalPresentational);
